// <s-recently-viewed> — two modes sharing one localStorage list (key "scx:recently-viewed").
//   record — on product pages: reads the JSON in its [data-product] script and stores it first.
//   (default) — renders the stored products, except data-exclude handles, as cards into
//   [data-list] using the <template data-card> markup, then unhides itself. Stays hidden when the
//   list is empty or storage is unavailable (Safari private mode, blocked storage): every access
//   is wrapped in try/catch.
const KEY = 'scx:recently-viewed';
const MAX = 12;

function readList() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter((p) => p && p.handle && typeof p.url === 'string' && p.url.startsWith('/') && !p.url.startsWith('//') && p.title) : [];
  } catch {
    return [];
  }
}

class SRecentlyViewed extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('record')) {
      this.#record();
      return;
    }
    this.#render();
  }

  #record() {
    try {
      const data = JSON.parse(this.querySelector('script[data-product]')?.textContent || 'null');
      if (!data || !data.handle) return;
      const list = readList().filter((p) => p.handle !== data.handle);
      list.unshift(data);
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch {
      // Storage unavailable: nothing to record.
    }
  }

  #render() {
    const exclude = (this.dataset.exclude || '').split(',').map((h) => h.trim()).filter(Boolean);
    const limit = Number(this.dataset.limit || 8);
    const items = readList().filter((p) => !exclude.includes(p.handle)).slice(0, limit);
    const list = this.querySelector('[data-list]');
    const template = this.querySelector('template[data-card]');
    if (!items.length || !list || !template) return;

    list.replaceChildren();
    for (const item of items) {
      const node = template.content.cloneNode(true);
      const link = node.querySelector('[data-link]');
      const img = node.querySelector('[data-image]');
      const title = node.querySelector('[data-title]');
      const price = node.querySelector('[data-price]');
      if (link) link.href = item.url;
      if (title) title.textContent = item.title;
      if (price) price.textContent = item.price || '';
      if (img) {
        if (item.image) {
          img.src = item.image;
          img.alt = item.title;
        } else {
          img.remove();
        }
      }
      list.append(node);
    }
    this.hidden = false;
  }
}

customElements.define('s-recently-viewed', SRecentlyViewed);
